/**
 * Code für die Immobilienkacheln. Nachladen und Filtern.
 *
 * Außerdem Code für "Vllt. auch interesannt für Sie"-Slider
 */


document.addEventListener("DOMContentLoaded", function() {

    /**
     * Immobilienfilter + Kacheln
     */

    const cardsContainer = document.querySelector('#estate-offerings-container');

    if(cardsContainer != null) {

        // init lazy load settings
        // filter wird in den blade initialisiert
        from = 0;
        offset = 4; // am anfang 4 Stück nachladen

        // initales abfragen und lazy loading von weiteren immobilienangeboten
        lazyLoadEstateOfferings = function (requestFrom) {

            axios.get('/ajax/estate-offerings?from=' + requestFrom + '&offset=' + offset + '&' + new URLSearchParams(filterSettings).toString())
                .then((response) => {

                    // nichts mehr gefunden?
                    if (response.data.length == 0) {
                        if (from == 0) {
                            cardsContainer.innerHTML = '<div class="col-12 text-center fade-in">Keine Angebote gefunden</div>';
                        }
                        return;
                    }

                    // temporäres element bauen
                    var wrapper= document.createElement('div');
                    wrapper.innerHTML= response.data;

                    // alte cards + neue cards
                    wrapper.querySelectorAll('.tile, .tile-cta, #add-more-offerings-btn > a')
                        .forEach(function(i) {
                            cardsContainer.append(i.parentElement);
                        });

                    // "mehr angebote" entfernen (weil wird wieder unten neu angehängt)
                    if(requestFrom > 0) {
                        document.querySelector('#add-more-offerings-btn').remove();
                    }

                    // fade-in via transition
                    setTimeout(function() {
                        cardsContainer.querySelectorAll("#estate-offerings-container > div")
                            .forEach(function(i) {
                                i.classList.add('fade-in');
                            });
                    }, 100) // damit der fade in funzt

                    from += offset;

                    // ab dem ersten laden nur noch 3 holen...
                    offset = 3;
                });
        }
        lazyLoadEstateOfferings(from); // init

        // filter zurücksetzen
        resetFilter = function() {
            filterSettings = {
                kaufen: null,
                mehrfamilienhaus: null,
                einfamilienhaus: null,
                wohnung: null,
                rendite_objekt: null,
                mallorca: null,
                mieten: null,
                grundstueck: null,
                gewerbe: null,
                parkplatz: null,
            }

            document.querySelectorAll('#offers-filter button')
                .forEach(i => i.classList.remove('active'));
        }

        // event für alle filter
        document.querySelectorAll('#offers-filter button, #clear-filters')
            .forEach(i => i.addEventListener('mouseup', function(event) {

                if(this.id == 'clear-filters') {
                    // alle filter zurücksetzen
                    resetFilter();
                }
                else {
                    // einzelnen filter hinzufügen oder entfernen

                    // last minute Änderung: nur ein Filter darf aktiv sein:
                    resetFilter();

                    // visuellen status ändern
                    this.classList.toggle('active');

                    // filter status anpassen
                    if(this.classList.contains('active')) {
                        filterSettings[this.dataset.filterColumn] = true;
                    }
                    else {
                        filterSettings[this.dataset.filterColumn] = null;
                    }
                }

                // Neue Suche mit verändertem Filter. Zustand der Ergebnisliste zurücksetzen. Dann neu abfragen.
                document.querySelector('#estate-offerings-container').innerHTML = '';
                from = 0;
                offset = 4;

                lazyLoadEstateOfferings(from);
            }));

    }




    /**
     * Detailseite Slider: "Vielleicht auch interessant"
     */

    const sliderContainer = document.querySelector('#estate-offerings-slider-container');

    if(sliderContainer != null) {

        // filter wird in detail blade definiert

        initGlideSlider = function() {

            new Glide('.glide', {
                type: 'carousel',
                startAt: 0,
                perView: 3,
                breakpoints: {
                    991: {
                        perView: 2,
                    },
                    575: {
                        perView: 1,
                    }
                }
            }).mount()

        };

        lazyLoadGlideSlider = function (requestFrom) {
            // in der übersicht brauchen wir divs, auf der Detailseite unter "Auch interessant" aber <li>
            axios.get('/ajax/estate-offerings?from=' + 0 + '&offset=' + 6 + '&' + new URLSearchParams(filterSettings).toString(),
                {
                    headers: {
                        // damit die blade entscheiden kann ob <div> oder <li> für die Kacheln verwendet werden sollen
                        'Use-List-Item-Tags': true,
                    }
                })
                .then((response) => {

                    // temporäres element bauen
                    var wrapper= document.createElement('div');
                    wrapper.innerHTML= response.data;

                    // slides anhängen
                    wrapper.querySelectorAll('li')
                        .forEach(function(slideElement) {
                            sliderContainer.append(slideElement);
                        });

                    initGlideSlider();

                });
        }
        lazyLoadGlideSlider(0); // init

    }

});
